<template>
  <div class="app-container">
    <div class="filter-container">
      <el-form :inline="true" label-position="top" label-width="100px" class="custom-form">
        <el-form-item :label="$t('member.memberName')" class="custom-item">
          <el-input
            :placeholder="$t('member.memberName')"
            v-model="listQuery.memberName"
            class="filter-item"
          />
        </el-form-item>
        <el-form-item :label="$t('member.phoneNum')" class="custom-item">
          <el-input
            :placeholder="$t('member.phoneNum')"
            v-model="listQuery.phoneNumber"
            class="filter-item"
          />
        </el-form-item>
        <el-form-item label="类型" class="custom-item">
          <el-input v-model="listQuery.type" placeholder="类型" class="filter-item" />
        </el-form-item>
        <el-form-item :label="$t('table.date')" class="custom-item">
          <el-date-picker
            v-model="btime"
            :default-time="['00:00:00','23:59:59']"
            type="datetimerange"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd HH:mm:ss"
            format="yyyy-MM-dd HH:mm:ss"
          />
        </el-form-item>
      </el-form>
      <p style="text-align:center">
        <el-button
          class="filter-item"
          type="primary"
          icon="el-icon-search"
          @click="handleFilter"
        >{{ $t('table.search') }}</el-button>
      </p>
      <el-table
        v-loading="listLoading"
        :data="historyList"
        border
        fit
        highlight-current-row
        style="width: 100%;"
      >
        <el-table-column label="会员名" align="center" width="80px">
          <template slot-scope="scope">
            <span>{{ scope.row.memberName }}</span>
          </template>
        </el-table-column>
        <el-table-column label="手机号码" align="center" width="120px">
          <template slot-scope="scope">
            <span>{{ scope.row.phoneNumber }}</span>
          </template>
        </el-table-column>
        <el-table-column label="类型" align="center" min-width="30px">
          <template slot-scope="scope">
            <span>{{ scope.row.type | typeFilter }}</span>
          </template>
        </el-table-column>
        <el-table-column label="剩余数量" align="center" min-width="40px">
          <template slot-scope="scope">
            <span>{{ scope.row.surplus }}</span>
          </template>
        </el-table-column>
        <el-table-column label="短信内容" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.content }}</span>
          </template>
        </el-table-column>
        <el-table-column label="时间" align="center" width="180px">
          <template slot-scope="scope">
            <span>{{ scope.row.createdTime }}</span>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-container">
        <el-pagination
          :current-page="listQuery.pi"
          :page-sizes="[10,20,30, 50]"
          :page-size="listQuery.ps"
          :total="total"
          background
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { list } from '@/api/sms'
export default {
  name: 'List',
  filters: {
    typeFilter(type) {
      let typeName = ''
      if (type === 1) {
        typeName = '加油'
      } else if (type === 2) {
        typeName = '充值'
      }
      return typeName
    }
  },
  data() {
    return {
      total: 0,
      listLoading: true,
      historyList: [],
      btime: [],
      listQuery: {
        pi: 1,
        ps: 20,
        memberName: '',
        phoneNumber: '',
        type: '',
        beginTime: '',
        endTime: ''
      }
    }
  },
  created() {
    this.getList()
  },
  methods: {
    handleFilter() {
      this.listLoading = true
      this.listQuery.pi = 1
      this.getList()
    },
    getList() {
      if (this.btime && this.btime.length) {
        this.listQuery.beginTime = this.btime[0]
        this.listQuery.endTime = this.btime[1]
      } else {
        this.listQuery.beginTime = ''
        this.listQuery.endTime = ''
      }
      list(this.listQuery).then(res => {
        const data = res.data.data
        this.historyList = data.items
        this.listLoading = false
      })
    },
    handleSizeChange(val) {
      this.listQuery.ps = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.listQuery.pi = val
      this.getList()
    }
  }
}
</script>

<style scoped>
</style>
